/**
 * Adapters for legacy table components used by the portfolio trading hub.
 *
 * These tables (UpdateTradesTable, UpdateMutualFundTradesTable,
 * BulkTradeRunAllocationsTable) live in pages/ and components/. They are also
 * imported statically by bulk trader and rebalance routes, so they are not
 * split into a separate async chunk — static imports here match bundling reality
 * and avoid ineffective dynamic-import warnings.
 */
import BulkTradeRunAllocationsTable from '@components/tables/bulkTradeRunAllocationsTable/bulkTradeRunAllocationsTable';
import UpdateMutualFundTradesTable from '@pages/legacy/bulkTrader/components/updateMutualFundTradesTable';
import UpdateTradesTable from '@pages/legacy/bulkTrader/components/updateTradesTable';
import type { ComponentProps } from 'react';

export const LegacyUpdateTradesTable = (
  props: ComponentProps<typeof UpdateTradesTable>,
) => <UpdateTradesTable {...props} />;

export const LegacyUpdateMutualFundTradesTable = (
  props: ComponentProps<typeof UpdateMutualFundTradesTable>,
) => <UpdateMutualFundTradesTable {...props} />;

export const LegacyBulkTradeRunAllocationsTable = (
  props: ComponentProps<typeof BulkTradeRunAllocationsTable>,
) => <BulkTradeRunAllocationsTable {...props} />;
